export default __webpack_public_path__ + "static/media/logo.bc05687b.png";